import React, { useEffect, useState } from 'react';
import Topbar from '../component/Topbar'
import { useLabels, useLang } from '../hooks/useLabels';
import { BiCalendarEdit, BiSolidTrash, BiLinkExternal, BiCopy, BiSearchAlt, BiCalendarPlus, BiBarChartAlt2 } from "react-icons/bi";
import { BsCalendar3, BsFillPersonPlusFill } from "react-icons/bs";
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useSearchParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingScreen from '../component/LoadingScreen';
import Moment from 'react-moment';
import ReactPaginate from 'react-paginate';
import { getImageSrc } from '../utils/imageSrc';
import moment from 'moment-timezone';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { InteractionStatus, InteractionType, InteractionRequiredAuthError, AccountInfo } from "@azure/msal-browser";
import { acquireGetAccessToken } from '../utils/GetGrapApi'
import { Buffer } from 'buffer';
import { callMsGraph, checkRole, UserRole } from '../callMsGroup';
import { saveRealRole, getEffectiveRole } from '../utils/roleOverride';
import {
    useMsal,
    MsalAuthenticationTemplate,
    useIsAuthenticated,
} from "@azure/msal-react";

function ConfirmModal(props: any) {

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.titleText || 'Confirm Delete'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {props.bodyText || 'Are you sure you want to delete this item?'}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>{props.cancelText || 'Cancel'}</Button>
                <Button variant="danger" onClick={props.onDelete}>{props.deleteText || 'Delete'}</Button>
            </Modal.Footer>
        </Modal>
    );
}
function EventGrid() {
    const { inProgress, instance, accounts } = useMsal();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [deletingEventNumber, setDeletingEventNumber] = useState("");
    const [role, setRole] = useState<UserRole>('owner')
    const [token, setToken] = useState("");
    const [lang] = useLang();
    const { t } = useLabels('eventgrid', token, 'en');
    const [profile, setProfile] = useState({ jobTitle: "" });
    const [photoData, setPhotoData] = useState("");
    const [tokenProfile, setTokenProfile] = useState("");
    const [stateLoad, setStateLoad] = useState(false);
    const [allEvents, setAllEvents] = useState<any[]>([]);
    const [eventNumber, setEventNumber] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const [keyword, setKeyword] = useState("");
    const [search, setSearch] = useState(false)
    const [currentPage, setCurrentPage] = useState(0);
    const PAGE_SIZE = 12;
    const [expiredFilter, setExpiredFilter] = useState<string>("active"); // "active" | "expired" | "all"
    const auths = {
        headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")
        }
    }
    const auth = {
        headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")
        },
        params: { keyword: keyword, limit: 500, offset: 0 }
    };
    const hendleConfirmModal = (evNumber: string) => {
        setEventNumber(evNumber);
        setModalShow(true);
    }

    const renderTooltip = (ownerString: string | null) => {
        const emails = (ownerString ?? '').split(',');
        return (
            <Tooltip id="button-tooltip">
              {emails.map((email: any, index: any) => (
                <div key={index}>{email}</div>
              ))}
            </Tooltip>
          );
      };

    const loadData = (silent = false) => {
        if (!silent) setLoading(true);
        axios.get(process.env.REACT_APP_API_END_POINT + '/v1/Events/events', auth)
            .then(function (response) {
                const list = response.data.eventsLists ?? response.data ?? [];
                const sorted = [...list].sort((a: any, b: any) =>
                    new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
                );
                setAllEvents(sorted);
                setStateLoad(true);
            })
            .catch(function (error) {
                // handle error
            })
            .finally(function () {
                if (!silent) setLoading(false);
            });
    }
    const hendleDelete = () => {
        setModalShow(false)
        setDeletingEventNumber(eventNumber)
        axios.delete(process.env.REACT_APP_API_END_POINT + '/v1/Events/delete?eventNumber=' + eventNumber, auths)
            .then(function (response) {
                loadData(true)
            })
            .catch(function (error) {
                setDeletingEventNumber("")
            });
    }
    const firstOwner = (owers: string | null) => {
        if (owers) {
            let arrOwner = owers.split(";");
            return arrOwner[0];
        } else {
            return t('label.owner_not_found', 'Owner not found');
        }
    }
    const copyUrl = async (url: string, evNumber: string) => {
        try {
            toast.success('Coppied ' + evNumber, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light"
            });
           // console.log("xxx")
            await navigator.clipboard.writeText(url);

        } catch (err) {
            //console.error('Failed to copy: ', err);
        }
    }
    const heandleSearch = (key: string) => {
        setKeyword(key);
        setCurrentPage(0);
        setSearch(true);
    }
    const handlePageClick = (event: any) => {
        setCurrentPage(event.selected);
    };

    useEffect(() => {
        if (search) loadData();
    }, [keyword]);

    useEffect(() => {
        setCurrentPage(0);
    }, [expiredFilter]);


    useEffect( () => {
        if (!token && inProgress === InteractionStatus.None) {
          acquireGetAccessToken(instance, accounts).then(async (res: any) => {
                if (!res) return;
                setToken(res.accessToken)
                setTokenProfile(res.accessTokenProfile)
                const response1 = await axios("https://graph.microsoft.com/v1.0/me/photo/$value", {
                    headers: { Authorization: `Bearer ${res.accessTokenProfile}` },
                    responseType: "arraybuffer"
                });
                const avatar = Buffer.from(response1.data, "binary").toString("base64");
                setPhotoData("data:image/jpeg;base64, " + avatar);
               // sessionStorage.setItem("PhotoData", "data:image/jpeg;base64, " + avatar);

                const response2 = await axios("https://graph.microsoft.com/v1.0/me", {
                    headers: { Authorization: `Bearer ${res.accessTokenProfile}` }
                });
                setProfile(response2.data);
               // sessionStorage.setItem("Profile", response2.data);

            }) 
        }
      }, [token,inProgress]);

    useEffect(() => {
        if (!token) return;
        loadData();
    }, [token]);


    useEffect(() => {
        const CheckRole = async () => {
                try {
                    //console.log('tokenProfile=====',tokenProfile);
                    if(tokenProfile){
                        const userRole = await checkRole(tokenProfile);
                        saveRealRole(userRole);
                        setRole(getEffectiveRole(userRole));
                        if (userRole === 'owner') {
                            window.location.href = window.location.origin + "/accessdenied"
                        }
                        // if(groupExists){
                        //     setStateLoad(true)
                        // }
                    }

                } catch (error) {
                    console.error(error);
                }
            }

        CheckRole();
    }, [token, tokenProfile])

    if (loading) {
        return <LoadingScreen />
    }


    const convertToG7 = (date: any) => moment.utc(date).tz('Asia/Bangkok').format('DD-MMM-YYYY');

    const isEventExpired = (startDate: any, endDate: any) => {
        if (!startDate || !endDate) return false;
        const today = moment.utc().tz('Asia/Bangkok').startOf('day');
        const eventStartDate = moment.utc(startDate).tz('Asia/Bangkok').startOf('day');
        const eventEndDate = moment.utc(endDate).tz('Asia/Bangkok').startOf('day');
        return eventStartDate.isSameOrBefore(today) && eventEndDate.isBefore(today);
    };

    const filteredEvents = allEvents.filter((item: any) => {
        if (expiredFilter === 'all') return true;
        const expired = isEventExpired(item.startDate, item.endDate);
        if (expiredFilter === 'active') return !expired;
        if (expiredFilter === 'expired') return expired;
        return true;
    });

    const totalPages = Math.ceil(filteredEvents.length / PAGE_SIZE);
    const pageEvents = filteredEvents.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);

    return (
        <>
         {(stateLoad) ? <>
            <div className="admin-layout">
                <Topbar triggerSearch={heandleSearch} token={token} photoData={photoData} role={role} />
                <main className="admin-main">
                    <div className='dt-container'>

                        {/* Header */}
                        <div className='dt-header'>
                            <div>
                                <div className='dt-title'>{t('section.title', 'All Events')}</div>
                                <div className='dt-subtitle'>{t('section.subtitle', 'Manage all events in the system')}</div>
                            </div>
                            <a className='btn btn-add' href='/events'>
                                <BiCalendarPlus /> {t('btn.create_event', 'Create Event')}
                            </a>
                        </div>

                        {/* Toolbar: Search + Filter */}
                        <div className='dt-toolbar'>
                            <div className='dt-search'>
                                <BiSearchAlt className='dt-search-icon' />
                                <input
                                    type='text'
                                    className='dt-search-input'
                                    placeholder={t('placeholder.search_events', 'Search events…')}
                                    value={keyword}
                                    onChange={(e) => setKeyword(e.target.value)}
                                    onKeyDown={(e) => { if (e.key === 'Enter') heandleSearch(keyword); }}
                                />
                                {keyword && (
                                    <button className='dt-search-clear' onClick={() => { setKeyword(""); heandleSearch(""); }}>×</button>
                                )}
                            </div>
                            <div className='dt-filter-group'>
                                <button className={`dt-filter-btn ${expiredFilter === 'active' ? 'active' : ''}`} onClick={() => setExpiredFilter('active')}>
                                    {t('filter.active', 'Active')}
                                </button>
                                <button className={`dt-filter-btn dt-filter-btn--expired ${expiredFilter === 'expired' ? 'active' : ''}`} onClick={() => setExpiredFilter('expired')}>
                                    {t('filter.expired', 'Expired')}
                                </button>
                                <button className={`dt-filter-btn dt-filter-btn--all ${expiredFilter === 'all' ? 'active' : ''}`} onClick={() => setExpiredFilter('all')}>
                                    {t('filter.all', 'All')}
                                </button>
                            </div>
                        </div>

                        {/* Table */}
                        <div className='dt-table-wrap'>
                            <table className='dt-table'>
                                <thead>
                                    <tr>
                                        <th>{t('table.col.event', 'Event')}</th>
                                        <th style={{ width: 200 }}>{t('table.col.date', 'Date')}</th>
                                        <th style={{ width: 160 }}>{t('table.col.owner', 'Owner')}</th>
                                        <th style={{ width: 220 }}>{t('table.col.email', 'Email')}</th>
                                        <th style={{ width: 120 }}>{t('table.col.members', 'Members')}</th>
                                        <th style={{ width: 80 }}>{t('table.col.status', 'Status')}</th>
                                        <th style={{ width: 140 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredEvents.length === 0 ? (
                                        <tr>
                                            <td colSpan={7} className='dt-empty'>
                                                <div>{t('empty.title', 'No data found')}</div>
                                                <small>{t('empty.hint', 'Try changing filters or search keyword')}</small>
                                            </td>
                                        </tr>
                                    ) : pageEvents.map((item: any, index: number) => {
                                            const expired = isEventExpired(item.startDate, item.endDate);
                                            return (
                                                <tr key={`A${index}`} className={expired ? 'dt-row--expired' : ''}>
                                                    <td>
                                                        <div className='dt-event-cell'>
                                                            <div className='dt-thumb'>
                                                                <img src={getImageSrc(item.image)} alt='' />
                                                            </div>
                                                            <div>
                                                                <div className='dt-event-name'>{item.eventName}</div>
                                                                <div className='dt-event-desc'>{item.description}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className='dt-date'>
                                                        {convertToG7(item.startDate)} <span className='dt-date-sep'>–</span> {convertToG7(item.endDate)}
                                                    </td>
                                                    <td>
                                                        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip(item.owner)}>
                                                            <span className='dt-owner'>{firstOwner(item.owner)}</span>
                                                        </OverlayTrigger>
                                                    </td>
                                                    <td>
                                                        <div className='dt-email-list'>
                                                            {item.owner ? item.owner.split(',').map((email: string, i: number) => (
                                                                <div key={i} className='dt-email-item'>{email.trim()}</div>
                                                            )) : '-'}
                                                        </div>
                                                    </td>
                                                    <td className='dt-members'>
                                                        <span className='dt-members-received'>{item.totalRecieved}</span>
                                                        <span className='dt-members-sep'>/</span>
                                                        <span>{item.memberGroup !== 3 ? item.totalMember : '∞'}</span>
                                                    </td>
                                                    <td>
                                                        {expired
                                                            ? <span className='dt-badge dt-badge--expired'>{t('filter.expired', 'Expired')}</span>
                                                            : <span className='dt-badge dt-badge--active'>{t('filter.active', 'Active')}</span>
                                                        }
                                                    </td>
                                                    <td>
                                                        <div className='dt-actions'>
                                                            <button className='dt-action-btn' title='Go to Event' onClick={() => navigate(`/event/${item.eventNumber}`)}>
                                                                <BiLinkExternal />
                                                            </button>
                                                            <button className='dt-action-btn' title='Copy URL' onClick={() => copyUrl(`${window.location.origin}/event/${item.eventNumber}`, item.eventNumber)}>
                                                                <BiCopy />
                                                            </button>
                                                            <button className='dt-action-btn' title='Report' onClick={() => navigate(`/event/${item.eventNumber}/report`)}>
                                                                <BiBarChartAlt2 />
                                                            </button>
                                                            <button className='dt-action-btn dt-action-btn--edit' title='Edit' onClick={() => navigate(`/events?id=${item.eventNumber}`)}>
                                                                <BiCalendarEdit />
                                                            </button>
                                                            <button className='dt-action-btn dt-action-btn--delete' title='Delete' onClick={() => hendleConfirmModal(item.eventNumber)} disabled={deletingEventNumber === item.eventNumber}>
                                                                {deletingEventNumber === item.eventNumber
                                                                    ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                                                    : <BiSolidTrash />}
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>

                        {/* Footer: count + pagination */}
                        <div className='dt-footer'>
                            <div className='dt-count'>
                                {t('label.showing', 'Showing')} {filteredEvents.length > 0 ? `${currentPage * PAGE_SIZE + 1}–${Math.min((currentPage + 1) * PAGE_SIZE, filteredEvents.length)}` : '0'} {t('label.of', 'of')} {filteredEvents.length} {t('label.events', 'events')}
                            </div>
                            {totalPages > 1 && (
                                <ReactPaginate
                                    previousLabel="‹"
                                    nextLabel="›"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    pageCount={totalPages}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={4}
                                    onPageChange={handlePageClick}
                                    containerClassName="pagination mb-0"
                                    activeClassName="active"
                                    forcePage={currentPage}
                                />
                            )}
                        </div>

                    </div>
                </main>
            </div>

            <ConfirmModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                onDelete={() => hendleDelete()}
                titleText={t('modal.confirm_delete', 'Confirm Delete')}
                bodyText={t('modal.delete_event_body', 'Are you sure you want to delete this item?')}
                cancelText={t('btn.cancel', 'Cancel')}
                deleteText={t('btn.delete', 'Delete')}
            />
            <ToastContainer />
            </>:<><LoadingScreen /></> }
        </>
       
    )
}

export default EventGrid
